import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { debounce, toNumber } from 'lodash';
import { ref, computed, onBeforeUnmount, onMounted } from 'vue';
import { fundSetupI18nText } from './i18n';
import { useShowDebugging } from '~/functions/accounts';
import { isFundSetupCompletionLeafKey, sustainableObjectiveFormCompletionKey, sustainableObjectiveFormCompletionSectionLabelKey } from '~/constants/fundSetupCompletion';
import { renderMarkdown } from '~/functions/markdown';
import { FUND_SETUP_ANCILLARY_SECTIONS, FUND_SETUP_BASIC_INFO_TABS, FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE, FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS, FUND_SETUP_SUSTAINABILITY_BASE_TABS, FUND_SETUP_TREE_KEYS } from '~/constants/fundSetupTree';
import { FundStrategy, useGetAccountQuery, useGetFundQuery, useGetFundSetupStateLazyQuery, useGetUserQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: '_fund',
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    var showDebugging = useShowDebugging();
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var currentLocale = computed(function () {
      return user.value.locale.substring(0, 2);
    });
    var fundId = computed(function () {
      var _route$params;
      return toNumber((_route$params = route.params) === null || _route$params === void 0 ? void 0 : _route$params.fund);
    });
    var _useGetFundQuery = useGetFundQuery({
        id: fundId.value
      }),
      result = _useGetFundQuery.result,
      loading = _useGetFundQuery.loading,
      onGetFundResult = _useGetFundQuery.onResult;
    var _useGetFundSetupState = useGetFundSetupStateLazyQuery({
        id: fundId.value
      }),
      setupStateResult = _useGetFundSetupState.result,
      loadSetupState = _useGetFundSetupState.load,
      refetchSetupState = _useGetFundSetupState.refetch;
    var isSetupStateRefreshing = ref(false);
    var setupStateRefreshInFlight = ref(false);
    var setupStateRefreshQueued = ref(false);
    var _runSetupStateRefresh = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!setupStateRefreshInFlight.value) {
                _context.next = 3;
                break;
              }
              setupStateRefreshQueued.value = true;
              return _context.abrupt("return");
            case 3:
              setupStateRefreshInFlight.value = true;
              isSetupStateRefreshing.value = true;
              _context.prev = 5;
              _context.next = 8;
              return Promise.resolve(loadSetupState() || refetchSetupState());
            case 8:
              _context.prev = 8;
              setupStateRefreshInFlight.value = false;
              isSetupStateRefreshing.value = false;
              if (setupStateRefreshQueued.value) {
                setupStateRefreshQueued.value = false;
                void _runSetupStateRefresh();
              }
              return _context.finish(8);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5,, 8, 13]]);
      }));
      return function runSetupStateRefresh() {
        return _ref.apply(this, arguments);
      };
    }();
    var scheduleSetupStateRefresh = debounce(function () {
      void _runSetupStateRefresh();
    }, 1000);
    onBeforeUnmount(function () {
      scheduleSetupStateRefresh.cancel();
    });
    onMounted(function () {
      void _runSetupStateRefresh();
    });
    onGetFundResult(function () {
      // Intentionally no sync refresh trigger here.
      // getFund emits frequently (including cache updates) and should not drive slow sync checks.
    });
    var fund = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getFund;
    });
    var sustainableObjectives = computed(function () {
      var _ref2, _fund$value$sustainab, _fund$value;
      return (_ref2 = _toConsumableArray((_fund$value$sustainab = (_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : _fund$value.sustainableObjectives) !== null && _fund$value$sustainab !== void 0 ? _fund$value$sustainab : [])) === null || _ref2 === void 0 ? void 0 : _ref2.sort(function (a, b) {
        var _a$concept, _a$concept$label, _b$concept;
        return (_a$concept = a.concept) === null || _a$concept === void 0 ? void 0 : (_a$concept$label = _a$concept.label) === null || _a$concept$label === void 0 ? void 0 : _a$concept$label.localeCompare((_b$concept = b.concept) === null || _b$concept === void 0 ? void 0 : _b$concept.label);
      });
    });
    var fundStrategy = computed(function () {
      var _fund$value2;
      return fund === null || fund === void 0 ? void 0 : (_fund$value2 = fund.value) === null || _fund$value2 === void 0 ? void 0 : _fund$value2.fundStrategy;
    });
    var isPaiOnly = computed(function () {
      var _fund$value3;
      return fundStrategy.value === FundStrategy.OnlyPais || fundStrategy.value === FundStrategy.Article_6 && ((_fund$value3 = fund.value) === null || _fund$value3 === void 0 ? void 0 : _fund$value3.isReportingPais) === true;
    });
    var isMediumOrDarkGreen = computed(function () {
      return fundStrategy.value === FundStrategy.Article_9 || fundStrategy.value === FundStrategy.Article_8Plus;
    });
    var questionTitle = function questionTitle(key) {
      var _fundSetupI18nText$qu, _fundSetupI18nText$qu2;
      return (_fundSetupI18nText$qu = fundSetupI18nText.questions[key]) === null || _fundSetupI18nText$qu === void 0 ? void 0 : (_fundSetupI18nText$qu2 = _fundSetupI18nText$qu.title) === null || _fundSetupI18nText$qu2 === void 0 ? void 0 : _fundSetupI18nText$qu2[currentLocale.value];
    };
    var completionDetailQuestionKeyByCanonical = {
      PORTFOLIO_NAME_OF_FINANCIAL_MARKET_PARTICIPANT_PRESENT: 'nameOfFinancialMarketParticipant',
      PORTFOLIO_LEGAL_ENTITY_IDENTIFIER_PRESENT: 'legalEntityIdentifier',
      FUND_NAME_PRESENT: 'fundName',
      FUND_LEGAL_ENTITY_IDENTIFIER_PRESENT: 'fundLegalEntityIdentifier',
      FUND_VOLUME_PRESENT: 'volume',
      FUND_INVESTMENT_PERIOD_PRESENT: 'investmentPeriod',
      FUND_VENTURES_ASSIGNED: 'ventureIds',
      FUND_STRATEGY_SELECTED: 'fundStrategy',
      NOT_CONSIDERING_PAIS_REASON_PRESENT: 'notConsideringPaisReason',
      PAI_REPORTING_DECISION_SET: 'isReportingPais',
      PAI_SOCIAL_METRICS_SELECTED: 'socialMetricIds',
      PAI_ENVIRONMENTAL_METRICS_SELECTED: 'environmentalMetricIds',
      PAI_SELECTION_METHODOLOGIES_PRESENT: 'paiSelectionMethodologies',
      PAI_POLICY_ADMINISTRATION_PRESENT: 'paiPolicyAdministration',
      KFW_COMPANY_ASSIGNMENT_COVERAGE: 'kfwVentureIds',
      ENTITY_SUSTAINABILITY_RISK_INTEGRATION_PRESENT: 'sustainabilityRiskIntegration',
      ENTITY_REMUNERATION_POLICIES_PRESENT: 'remunerationPolicies',
      SUSTAINABILITY_RISK_DECISION_RECORDED: 'isConsideringSustainabilityRisk',
      SUSTAINABILITY_RISK_INTEGRATION_DESCRIPTION_PRESENT: 'sustainabilityRiskIntegrationDescription',
      LIKELY_IMPACTS_FROM_SUSTAINABILITY_RISK_PRESENT: 'likelyImpactsFromSustainabilityRisk',
      REASON_NOT_CONSIDERING_SUSTAINABILITY_RISK_PRESENT: 'reasonNotConsideringSustainabilityRisk'
    };
    var completionQuestionIxIdAliases = {
      conceptId: 'concept'
    };
    var completionLabelFromApiDetail = function completionLabelFromApiDetail(detail) {
      var ixId = (detail === null || detail === void 0 ? void 0 : detail.key) || completionDetailQuestionKeyByCanonical[detail === null || detail === void 0 ? void 0 : detail.canonicalKey] || (detail === null || detail === void 0 ? void 0 : detail.canonicalKey);
      var questionKey = completionQuestionIxIdAliases[ixId] || ixId;
      if (questionKey) {
        return questionTitle(questionKey) || (detail === null || detail === void 0 ? void 0 : detail.why) || questionKey;
      }
      return (detail === null || detail === void 0 ? void 0 : detail.why) || ixId;
    };
    var normalizeCompletionResult = function normalizeCompletionResult(item) {
      if ((item === null || item === void 0 ? void 0 : item.result) !== null && (item === null || item === void 0 ? void 0 : item.result) !== undefined) return item.result;
      return (item === null || item === void 0 ? void 0 : item.applicable) === false ? 1 : 0;
    };
    var normalizeCompletionItems = function normalizeCompletionItems(details) {
      return (details || []).filter(function (d) {
        return (d === null || d === void 0 ? void 0 : d.applicable) !== false;
      }).map(function (d) {
        return {
          result: normalizeCompletionResult(d),
          why: completionLabelFromApiDetail(d)
        };
      });
    };
    var apiCompletionItems = computed(function () {
      var _setupStateResult$val, _setupStateResult$val2, _setupStateResult$val3;
      return ((_setupStateResult$val = setupStateResult.value) === null || _setupStateResult$val === void 0 ? void 0 : (_setupStateResult$val2 = _setupStateResult$val.fundSetupState) === null || _setupStateResult$val2 === void 0 ? void 0 : (_setupStateResult$val3 = _setupStateResult$val2.completion) === null || _setupStateResult$val3 === void 0 ? void 0 : _setupStateResult$val3.items) || [];
    });
    var apiCompletionByLegacyKey = computed(function () {
      var map = new Map();
      var _iterator = _createForOfIteratorHelper(apiCompletionItems.value),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          map.set(item.key, item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return map;
    });
    var completionFromApi = function completionFromApi(legacyKey) {
      var section = apiCompletionByLegacyKey.value.get(legacyKey);
      if (!section) {
        return {
          result: 0,
          items: []
        };
      }
      return {
        result: normalizeCompletionResult(section),
        items: normalizeCompletionItems(section.details)
      };
    };
    var completionPortfolioSection = computed(function () {
      var section = apiCompletionByLegacyKey.value.get('basicInfo');
      if (!section) return {
        result: 0,
        items: []
      };
      var details = (section.details || []).filter(function (d) {
        return ['PORTFOLIO_NAME_OF_FINANCIAL_MARKET_PARTICIPANT_PRESENT', 'PORTFOLIO_LEGAL_ENTITY_IDENTIFIER_PRESENT'].includes(d === null || d === void 0 ? void 0 : d.canonicalKey);
      });
      var items = normalizeCompletionItems(details);
      var result = items.length > 0 ? items.reduce(function (sum, i) {
        return sum + (i.result || 0);
      }, 0) / items.length : 0;
      return {
        result: result,
        items: items
      };
    });
    var completionFundSection = computed(function () {
      var section = apiCompletionByLegacyKey.value.get('basicInfo');
      if (!section) return {
        result: 0,
        items: []
      };
      var details = (section.details || []).filter(function (d) {
        return !['PORTFOLIO_NAME_OF_FINANCIAL_MARKET_PARTICIPANT_PRESENT', 'PORTFOLIO_LEGAL_ENTITY_IDENTIFIER_PRESENT'].includes(d === null || d === void 0 ? void 0 : d.canonicalKey);
      });
      var items = normalizeCompletionItems(details);
      var result = items.length > 0 ? items.reduce(function (sum, i) {
        return sum + (i.result || 0);
      }, 0) / items.length : 0;
      return {
        result: result,
        items: items
      };
    });
    var averagePercentageCompleted = function averagePercentageCompleted(values) {
      var nums = values.filter(function (value) {
        return typeof value === 'number' && value >= 0 && value <= 1;
      });
      if (nums.length === 0) return 0;
      return nums.reduce(function (sum, value) {
        return sum + value;
      }, 0) / nums.length;
    };
    var rollupCompletionItems = function rollupCompletionItems(children) {
      return children.flatMap(function (child) {
        return child.completionItems || [];
      });
    };
    var _applyCompletionRollup = function applyCompletionRollup(section) {
      var _section$sections;
      if (!(section !== null && section !== void 0 && (_section$sections = section.sections) !== null && _section$sections !== void 0 && _section$sections.length)) {
        return section;
      }
      var children = section.sections.map(_applyCompletionRollup);
      if (!section.skip) {
        return _objectSpread(_objectSpread({}, section), {}, {
          sections: children
        });
      }
      return _objectSpread(_objectSpread({}, section), {}, {
        sections: children,
        percentageCompleted: averagePercentageCompleted(children.map(function (child) {
          return child.percentageCompleted;
        })),
        completionItems: rollupCompletionItems(children)
      });
    };
    var getTextByPath = function getTextByPath(path) {
      var _path$split$reduce;
      return (_path$split$reduce = path.split('.').reduce(function (acc, key) {
        return acc === null || acc === void 0 ? void 0 : acc[key];
      }, fundSetupI18nText)) === null || _path$split$reduce === void 0 ? void 0 : _path$split$reduce[currentLocale.value];
    };
    var getDefaultDynamicProps = function getDefaultDynamicProps(sectionId) {
      var _account$value, _account$value2;
      var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _objectSpread({
        sectionId: sectionId,
        fundId: fundId.value,
        accountId: (_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.id,
        portfolioId: (_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.id
      }, extraProps);
    };
    var buildDynamicContent = function buildDynamicContent(id, sectionId) {
      var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return {
        id: id,
        component: 'sfdr-section-fund-setup-dynamic',
        props: getDefaultDynamicProps(sectionId, extraProps),
        events: {}
      };
    };
    var sustainableObjectiveFundLevelCompletion = computed(function () {
      return completionFromApi('sustainableObjectiveFundLevel');
    });
    var sustainableObjectiveFormCompletion = function sustainableObjectiveFormCompletion(objectiveId) {
      return completionFromApi(sustainableObjectiveFormCompletionKey(objectiveId));
    };
    var buildSustainableObjectiveEditSections = function buildSustainableObjectiveEditSections() {
      return sustainableObjectives.value.map(function (objective, index) {
        var _objective$concept;
        return {
          id: FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.EDIT.idPrefix + objective.id,
          name: getTextByPath(FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.EDIT.namePath) + ((objective === null || objective === void 0 ? void 0 : (_objective$concept = objective.concept) === null || _objective$concept === void 0 ? void 0 : _objective$concept.label) || index + 1),
          header: getTextByPath(FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.EDIT.headerPath),
          percentageCompleted: sustainableObjectiveFormCompletion(objective.id).result,
          completionItems: sustainableObjectiveFormCompletion(objective.id).items,
          content: [buildDynamicContent("".concat(FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.EDIT.contentIdPrefix).concat(objective.id), FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.EDIT.sectionId, {
            sfdrStrategyId: objective.id
          })]
        };
      });
    };
    var sections = computed(function () {
      var _fund$value4, _fund$value4$esCharac, _fund$value5, _account$value3, _fund$value6, _fund$value7;
      var basicInfoTabs = FUND_SETUP_BASIC_INFO_TABS.map(function (tab, index) {
        return {
          id: tab.id,
          name: getTextByPath(tab.namePath),
          header: getTextByPath(tab.headerPath),
          percentageCompleted: index === 0 ? completionPortfolioSection.value.result : completionFundSection.value.result,
          completionItems: index === 0 ? completionPortfolioSection.value.items : completionFundSection.value.items,
          content: [buildDynamicContent(tab.contentId, tab.sectionId)]
        };
      });
      var sustainabilityBaseTabs = FUND_SETUP_SUSTAINABILITY_BASE_TABS.map(function (tab) {
        return {
          id: tab.id,
          name: getTextByPath(tab.namePath),
          header: getTextByPath(tab.headerPath),
          percentageCompleted: completionFromApi(tab.completionKey).result,
          completionItems: completionFromApi(tab.completionKey).items,
          content: [buildDynamicContent(tab.contentId, tab.sectionId)]
        };
      });
      return [{
        id: FUND_SETUP_TREE_KEYS.INTRO.id,
        name: getTextByPath(FUND_SETUP_TREE_KEYS.INTRO.namePath),
        header: getTextByPath(FUND_SETUP_TREE_KEYS.INTRO.headerPath),
        content: [{
          id: 'sfdrIntroStepper',
          component: 'sfdr-intro-stepper',
          props: {}
        }]
      }, {
        id: FUND_SETUP_TREE_KEYS.BASIC_INFO.id,
        name: getTextByPath(FUND_SETUP_TREE_KEYS.BASIC_INFO.namePath),
        skip: true,
        percentageCompleted: completionFromApi('basicInfo').result,
        completionItems: completionFromApi('basicInfo').items,
        content: [],
        sections: basicInfoTabs
      }, {
        id: FUND_SETUP_TREE_KEYS.SUSTAINABILITY_APPROACH.id,
        name: getTextByPath(FUND_SETUP_TREE_KEYS.SUSTAINABILITY_APPROACH.namePath),
        skip: true,
        percentageCompleted: 0,
        completionItems: [],
        content: [],
        sections: [].concat(_toConsumableArray(sustainabilityBaseTabs), _toConsumableArray(fundStrategy.value === FundStrategy.Article_8 || fundStrategy.value === FundStrategy.Article_8Plus ? [{
          id: FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.ES_CHARACTERISTICS.id,
          name: getTextByPath(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.ES_CHARACTERISTICS.namePath),
          header: getTextByPath(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.ES_CHARACTERISTICS.headerPath),
          percentageCompleted: completionFromApi(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.ES_CHARACTERISTICS.completionKey).result,
          completionItems: completionFromApi(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.ES_CHARACTERISTICS.completionKey).items,
          content: [buildDynamicContent(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.ES_CHARACTERISTICS.contentId, FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.ES_CHARACTERISTICS.sectionId, {
            sfdrStrategyId: fund === null || fund === void 0 ? void 0 : (_fund$value4 = fund.value) === null || _fund$value4 === void 0 ? void 0 : (_fund$value4$esCharac = _fund$value4.esCharacteristics) === null || _fund$value4$esCharac === void 0 ? void 0 : _fund$value4$esCharac.id
          })]
        }] : []), _toConsumableArray(isMediumOrDarkGreen.value ? [{
          id: FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.CONTAINER.id,
          name: getTextByPath(FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.CONTAINER.namePath),
          skip: true,
          sections: [{
            id: FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.SELECT.id,
            name: getTextByPath(FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.SELECT.namePath),
            header: getTextByPath(FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.SELECT.headerPath),
            percentageCompleted: sustainableObjectives.value.length > 0 ? sustainableObjectiveFundLevelCompletion.value.result : 0,
            completionItems: sustainableObjectiveFundLevelCompletion.value.items,
            content: [{
              id: FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.SELECT.contentId,
              component: FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.SELECT.component,
              props: {
                sectionId: FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.SELECT.sectionId,
                sustainableObjectives: sustainableObjectives.value,
                fundId: fund === null || fund === void 0 ? void 0 : (_fund$value5 = fund.value) === null || _fund$value5 === void 0 ? void 0 : _fund$value5.id,
                portfolioId: (_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.id,
                fund: fund === null || fund === void 0 ? void 0 : fund.value
              },
              events: {
                navigateToSustainableObjective: function navigateToSustainableObjective(id) {
                  onSectionSelect(FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE.EDIT.idPrefix + id);
                }
              }
            }]
          }].concat(_toConsumableArray(buildSustainableObjectiveEditSections()))
        }] : []), [{
          id: FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.SUSTAINABILITY_RISK.id,
          name: getTextByPath(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.SUSTAINABILITY_RISK.namePath),
          header: getTextByPath(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.SUSTAINABILITY_RISK.headerPath),
          percentageCompleted: completionFromApi(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.SUSTAINABILITY_RISK.completionKey).result,
          completionItems: completionFromApi(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.SUSTAINABILITY_RISK.completionKey).items,
          content: [buildDynamicContent(FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.SUSTAINABILITY_RISK.contentId, FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS.SUSTAINABILITY_RISK.sectionId)]
        }])
      }].concat(_toConsumableArray((_fund$value6 = fund.value) !== null && _fund$value6 !== void 0 && _fund$value6.isReportingPais ? [paiSection.value] : []), _toConsumableArray((_fund$value7 = fund.value) !== null && _fund$value7 !== void 0 && _fund$value7.isReportingKfw ? [kfwSection.value] : []));
    });

    // Sections: generalKpisSection, hiddenKpiSection, paiSection, kfwSection

    var paiSection = computed(function () {
      return {
        id: FUND_SETUP_ANCILLARY_SECTIONS.PAI.id,
        name: getTextByPath(FUND_SETUP_ANCILLARY_SECTIONS.PAI.namePath),
        header: getTextByPath(FUND_SETUP_ANCILLARY_SECTIONS.PAI.headerPath),
        percentageCompleted: completionFromApi(FUND_SETUP_ANCILLARY_SECTIONS.PAI.completionKey).result,
        completionItems: completionFromApi(FUND_SETUP_ANCILLARY_SECTIONS.PAI.completionKey).items,
        content: [{
          id: FUND_SETUP_ANCILLARY_SECTIONS.PAI.introComponentId,
          component: FUND_SETUP_ANCILLARY_SECTIONS.PAI.introComponent,
          props: {
            isPaiOnly: isPaiOnly.value
          }
        }, _objectSpread({}, buildDynamicContent(FUND_SETUP_ANCILLARY_SECTIONS.PAI.contentId, FUND_SETUP_ANCILLARY_SECTIONS.PAI.sectionId))]
      };
    });
    var kfwSection = computed(function () {
      return {
        id: FUND_SETUP_ANCILLARY_SECTIONS.KFW.id,
        name: getTextByPath(FUND_SETUP_ANCILLARY_SECTIONS.KFW.namePath),
        header: getTextByPath(FUND_SETUP_ANCILLARY_SECTIONS.KFW.headerPath),
        percentageCompleted: completionFromApi(FUND_SETUP_ANCILLARY_SECTIONS.KFW.completionKey).result,
        completionItems: completionFromApi(FUND_SETUP_ANCILLARY_SECTIONS.KFW.completionKey).items,
        content: [_objectSpread({}, buildDynamicContent(FUND_SETUP_ANCILLARY_SECTIONS.KFW.contentId, FUND_SETUP_ANCILLARY_SECTIONS.KFW.sectionId))]
      };
    });
    var hiddenKpiSection = computed(function () {
      return {
        id: FUND_SETUP_ANCILLARY_SECTIONS.HIDDEN_KPIS.id,
        name: getTextByPath(FUND_SETUP_ANCILLARY_SECTIONS.HIDDEN_KPIS.namePath),
        header: getTextByPath(FUND_SETUP_ANCILLARY_SECTIONS.HIDDEN_KPIS.headerPath),
        percentageCompleted: null,
        completionItems: [],
        content: [{
          id: FUND_SETUP_ANCILLARY_SECTIONS.HIDDEN_KPIS.introComponentId,
          component: FUND_SETUP_ANCILLARY_SECTIONS.HIDDEN_KPIS.introComponent,
          props: {},
          events: {}
        }, _objectSpread({}, buildDynamicContent(FUND_SETUP_ANCILLARY_SECTIONS.HIDDEN_KPIS.contentId, FUND_SETUP_ANCILLARY_SECTIONS.HIDDEN_KPIS.sectionId))]
      };
    });
    var generalKpisSection = computed(function () {
      return {
        id: FUND_SETUP_ANCILLARY_SECTIONS.GENERAL_KPIS.id,
        name: getTextByPath(FUND_SETUP_ANCILLARY_SECTIONS.GENERAL_KPIS.namePath),
        header: getTextByPath(FUND_SETUP_ANCILLARY_SECTIONS.GENERAL_KPIS.headerPath),
        percentageCompleted: 1,
        completionItems: [],
        content: [{
          id: FUND_SETUP_ANCILLARY_SECTIONS.GENERAL_KPIS.introComponentId,
          component: FUND_SETUP_ANCILLARY_SECTIONS.GENERAL_KPIS.introComponent,
          props: {},
          events: {}
        }, _objectSpread({}, buildDynamicContent(FUND_SETUP_ANCILLARY_SECTIONS.GENERAL_KPIS.contentId, FUND_SETUP_ANCILLARY_SECTIONS.GENERAL_KPIS.sectionId))]
      };
    });
    var incompleteCompletionDetails = function incompleteCompletionDetails(section) {
      var _section$result;
      var incompleteDetails = (section.details || []).filter(function (detail) {
        var _detail$result;
        return (detail === null || detail === void 0 ? void 0 : detail.applicable) !== false && ((_detail$result = detail === null || detail === void 0 ? void 0 : detail.result) !== null && _detail$result !== void 0 ? _detail$result : 0) < 1 && ((detail === null || detail === void 0 ? void 0 : detail.key) || (detail === null || detail === void 0 ? void 0 : detail.why));
      });
      if (incompleteDetails.length) {
        return incompleteDetails.map(function (detail) {
          return {
            result: detail.result,
            why: completionLabelFromApiDetail(detail),
            key: detail.key,
            canonicalKey: detail.canonicalKey
          };
        });
      }
      if (section.why && ((_section$result = section.result) !== null && _section$result !== void 0 ? _section$result : 0) < 1) {
        return [{
          result: section.result,
          why: section.why
        }];
      }
      return [];
    };

    // Leaf API sections only (omit combined aggregates e.g. sustainableObjectiveSection).
    var completionTableItems = computed(function () {
      var _setupStateResult$val4, _setupStateResult$val5, _setupStateResult$val6;
      var apiItems = (_setupStateResult$val4 = setupStateResult.value) === null || _setupStateResult$val4 === void 0 ? void 0 : (_setupStateResult$val5 = _setupStateResult$val4.fundSetupState) === null || _setupStateResult$val5 === void 0 ? void 0 : (_setupStateResult$val6 = _setupStateResult$val5.completion) === null || _setupStateResult$val6 === void 0 ? void 0 : _setupStateResult$val6.items;
      if (!(apiItems !== null && apiItems !== void 0 && apiItems.length)) return [];
      return apiItems.filter(function (item) {
        return item.applicable !== false && item.result !== 1 && isFundSetupCompletionLeafKey(item.key);
      }).map(function (item) {
        return {
          section: sustainableObjectiveFormCompletionSectionLabelKey(item.key),
          result: item.result,
          items: incompleteCompletionDetails(item)
        };
      }).filter(function (row) {
        return row.items.length > 0;
      });
    });
    var onSectionSelect = function onSectionSelect(id) {
      router.push({
        query: {
          step: id
        }
      });
    };
    var missingQuestions = function missingQuestions(items) {
      var _items$filter;
      return items === null || items === void 0 ? void 0 : (_items$filter = items.filter(function (e) {
        return (e === null || e === void 0 ? void 0 : e.result) < 1;
      })) === null || _items$filter === void 0 ? void 0 : _items$filter.map(function (e) {
        return e === null || e === void 0 ? void 0 : e.why;
      });
    };
    var missingQuestionsText = function missingQuestionsText(items) {
      var _fundSetupI18nText$wa, _missingQuestions;
      var warningMissingQuestions = fundSetupI18nText === null || fundSetupI18nText === void 0 ? void 0 : (_fundSetupI18nText$wa = fundSetupI18nText.warningMissingQuestions) === null || _fundSetupI18nText$wa === void 0 ? void 0 : _fundSetupI18nText$wa[currentLocale.value];
      var questions = ((_missingQuestions = missingQuestions(items)) === null || _missingQuestions === void 0 ? void 0 : _missingQuestions.map(function (question) {
        return "- ".concat(question);
      }).join('\n')) || '';
      return "".concat(warningMissingQuestions, "\n").concat(questions);
    };
    var items = computed(function () {
      var tree = [].concat(_toConsumableArray(sections.value), [generalKpisSection.value, hiddenKpiSection.value], [{
        id: FUND_SETUP_TREE_KEYS.OUTRO.id,
        name: getTextByPath(FUND_SETUP_TREE_KEYS.OUTRO.namePath),
        percentageCompleted: null,
        completionItems: [],
        content: [{
          id: 'sfdrOutroStepper',
          component: 'sfdr-outro-stepper',
          props: {
            fund: fund === null || fund === void 0 ? void 0 : fund.value,
            mandatoryQuestionsAnswered: completionTableItems.value.length === 0,
            completionTableItems: completionTableItems.value
          },
          events: {
            submit: function submit() {
              scheduleSetupStateRefresh();
            }
          }
        }]
      }]);
      return tree.map(function (section) {
        return _applyCompletionRollup(section);
      });
    });
    return {
      __sfc: true,
      router: router,
      route: route,
      userResult: userResult,
      accountResult: accountResult,
      user: user,
      showDebugging: showDebugging,
      account: account,
      currentLocale: currentLocale,
      fundId: fundId,
      result: result,
      loading: loading,
      onGetFundResult: onGetFundResult,
      setupStateResult: setupStateResult,
      loadSetupState: loadSetupState,
      refetchSetupState: refetchSetupState,
      isSetupStateRefreshing: isSetupStateRefreshing,
      setupStateRefreshInFlight: setupStateRefreshInFlight,
      setupStateRefreshQueued: setupStateRefreshQueued,
      runSetupStateRefresh: _runSetupStateRefresh,
      scheduleSetupStateRefresh: scheduleSetupStateRefresh,
      fund: fund,
      sustainableObjectives: sustainableObjectives,
      fundStrategy: fundStrategy,
      isPaiOnly: isPaiOnly,
      isMediumOrDarkGreen: isMediumOrDarkGreen,
      questionTitle: questionTitle,
      completionDetailQuestionKeyByCanonical: completionDetailQuestionKeyByCanonical,
      completionQuestionIxIdAliases: completionQuestionIxIdAliases,
      completionLabelFromApiDetail: completionLabelFromApiDetail,
      normalizeCompletionResult: normalizeCompletionResult,
      normalizeCompletionItems: normalizeCompletionItems,
      apiCompletionItems: apiCompletionItems,
      apiCompletionByLegacyKey: apiCompletionByLegacyKey,
      completionFromApi: completionFromApi,
      completionPortfolioSection: completionPortfolioSection,
      completionFundSection: completionFundSection,
      averagePercentageCompleted: averagePercentageCompleted,
      rollupCompletionItems: rollupCompletionItems,
      applyCompletionRollup: _applyCompletionRollup,
      getTextByPath: getTextByPath,
      getDefaultDynamicProps: getDefaultDynamicProps,
      buildDynamicContent: buildDynamicContent,
      sustainableObjectiveFundLevelCompletion: sustainableObjectiveFundLevelCompletion,
      sustainableObjectiveFormCompletion: sustainableObjectiveFormCompletion,
      buildSustainableObjectiveEditSections: buildSustainableObjectiveEditSections,
      sections: sections,
      paiSection: paiSection,
      kfwSection: kfwSection,
      hiddenKpiSection: hiddenKpiSection,
      generalKpisSection: generalKpisSection,
      incompleteCompletionDetails: incompleteCompletionDetails,
      completionTableItems: completionTableItems,
      onSectionSelect: onSectionSelect,
      missingQuestions: missingQuestions,
      missingQuestionsText: missingQuestionsText,
      items: items,
      renderMarkdown: renderMarkdown
    };
  }
});